import ImageThumbnail from './ImageThumbnail.container';

export default ImageThumbnail;
